var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg25E075Afe4052321E6C950A3Fafcc4849F3D61D1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 1921 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M1921 1080H0V0H1921V1080Z",
    fill: "url(#paint0_radial_2002_64)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2002_64",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(961 -6.13159e-06) rotate(90) scale(442.5 2176.7)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002E2A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg25E075Afe4052321E6C950A3Fafcc4849F3D61D1);
export default __webpack_public_path__ + "static/media/25e075afe4052321e6c950a3fafcc4849f3d61d1.ac3f28f1b0a199e49eb1dd56ee270fc2.svg";
export { ForwardRef as ReactComponent };